import { Tabs, Row } from "antd";
import { LaserClassResultsV2 } from "../../pages/Loginv2/Calculators/Results/MPE_AEL_Results/LaserClassResultsV2";
import LaserClassVerdict from "../../pages/Loginv2/Calculators/Results/MPE_AEL_Results/LaserClassVerdict";
import { AELTab } from "./AEL";
import { useTranslation } from "react-i18next";
export function AllAEL(props){
    const { t } = useTranslation();
        return(
        <Tabs
            style={{width:"100%"}}
            centered
            items={[
            {
                key: 1,
                label: t('10131') /*Overall*/,
                children:
                <>
                        <LaserClassResultsV2 laserClass={props.laserClass} condition={1} />
                        {props.laserClass.laserOperation.includes("FO") ? 
                        <LaserClassResultsV2 laserClass={props.laserClass} condition={2} /> : null
                        }
                        <LaserClassResultsV2 laserClass={props.laserClass} condition={3} />
                        <LaserClassVerdict laserClass={props.laserClass} />
                </>
            },
            {
                key: 2,
                label: `${t('10132')} 1` /*Class 1*/,
                children: 
                <>
                    <AELTab class={"1"} laserClass={props.laserClass} laserOperation={props.laserOperation}/>
                </>
            },
            {
                key: 3,
                label: `${t('10132')} 2` /*Class 2*/,
                children:   
                <>
                    <AELTab class={"2"} laserClass={props.laserClass} laserOperation={props.laserOperation}/>
                </>
            },
            {
                key: 4,
                label: `${t('10132')} 3R` /*Class 3R*/,
                children:  
                <>
                    <AELTab class={"3r"} laserClass={props.laserClass} laserOperation={props.laserOperation}/>
                </>
            },
            {
                key: 5,
                label: `${t('10132')} 3B` /*Class 3B*/,
                children:   
                <>
                    <AELTab class={"3b"} laserClass={props.laserClass} laserOperation={props.laserOperation}/>
                </>
            }

        ]}
        />
    )
}